import { Highlights, HighlightsItem, HighlightsTextItem } from '@cmg/design-system';
import { FC, Fragment } from 'react';

import { isIPOType } from '../../../../common/util/offering/offeringTypeHelpers';
import { OfferingStatusChip } from '../../../../design-system/components/data-display/offering-status-chip/OfferingStatusChip';
import {
  OfferingStatus as OfferingStatusEnum,
  OfferingType,
  Sector,
  SecurityType,
} from '../../../../graphql';
import { sectorLabels } from '../../../constants';
import { Offering_OfferingHeader_OfferingTermsPartsFragment } from '../../graphql';
import LastTradeBeforeTitleItems from './components/LastTradeBeforeTitleItems';
import { FOPricingTitleItem, IPOPricingTitleItem } from './components/PricingTitleItems';
import SizeInSharesTitleItem from './components/SizeInSharesTitleItem';

type Props = {
  issuerName: string;
  type?: OfferingType;
  isCreateNewOffering: boolean;
  sector?: Sector | null;
  securityType?: SecurityType;
  sizeInShares?: number | null;
  terms?: Offering_OfferingHeader_OfferingTermsPartsFragment;
  pricingCurrencyCode?: string;
  status?: OfferingStatusEnum;
  offeringTypeLabel: string;
};

export const OfferingHighlights: FC<Props> = ({
  issuerName,
  type,
  isCreateNewOffering,
  sector,
  securityType,
  sizeInShares,
  terms,
  pricingCurrencyCode,
  status,
  offeringTypeLabel,
}) => {
  return (
    <Highlights
      data-testid="offering-header-highlights"
      title={issuerName}
      titleItems={
        !isCreateNewOffering ? (
          <Fragment>
            {type && (
              <HighlightsTextItem
                data-testid="offering-type-highlight"
                name="OFFERING TYPE"
                text={offeringTypeLabel}
              />
            )}
            <HighlightsTextItem name="SECTOR" text={sector ? sectorLabels[sector] : '-'} />
            {securityType && (
              <SizeInSharesTitleItem securityType={securityType} sizeInShares={sizeInShares} />
            )}
            {isIPOType(type!) ? (
              <IPOPricingTitleItem terms={terms} pricingCurrencyCode={pricingCurrencyCode} />
            ) : (
              <Fragment>
                <FOPricingTitleItem terms={terms} pricingCurrencyCode={pricingCurrencyCode} />
                <LastTradeBeforeTitleItems
                  terms={terms}
                  pricingCurrencyCode={pricingCurrencyCode}
                />
              </Fragment>
            )}
            {status && (
              <HighlightsItem
                name="OFFERING STATUS"
                value={<OfferingStatusChip status={status} />}
              />
            )}
          </Fragment>
        ) : null
      }
    />
  );
};
